import { render, staticRenderFns } from "./ReturnedItems.vue?vue&type=template&id=76ed7520&scoped=true&"
import script from "./ReturnedItems.vue?vue&type=script&lang=js&"
export * from "./ReturnedItems.vue?vue&type=script&lang=js&"
import style0 from "./ReturnedItems.vue?vue&type=style&index=0&id=76ed7520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ed7520",
  null
  
)

export default component.exports